import {
    GET_SPLUNK_REFRESH,
    GET_SPLUNK_REFRESH_SUCCESS,
    GET_SPLUNK_REFRESH_FAIL,
    GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE,
    GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    GET_ALL_ORG_SPLUNK_RESOURCE_TYPES,
    GET_ALL_ORG_SPLUNK_RESOURCE_TYPES_SUCCESS,
    GET_ALL_ORG_SPLUNK_RESOURCE_TYPES_FAIL,
    GET_SPLUNK_ALL_RESOURCE_COUNT,
    GET_SPLUNK_ALL_RESOURCE_COUNT_SUCCESS,
    GET_SPLUNK_ALL_RESOURCE_COUNT_FAIL,
    GET_USER_RESCAN_STATUS_SPLUNK,
    GET_USER_RESCAN_STATUS_SPLUNK_SUCCESS,
    GET_USER_RESCAN_STATUS_SPLUNK_FAIL,
    POST_SPLUNK_SERVICE_MAPPING,
    POST_SPLUNK_SERVICE_MAPPING_SUCCESS,
    POST_SPLUNK_SERVICE_MAPPING_FAIL,
    POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING,
    POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING_SUCCESS,
    POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING_FAIL,
    GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE,
    GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_FAIL,
    GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT,
    GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_SUCCESS,
    GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_FAIL,
    GET_SPLUNK_ALERTS,
    GET_SPLUNK_ALERTS_SUCCESS,
    GET_SPLUNK_ALERTS_FAIL,
    GET_SPLUNK_DEFAULT_THRESHOLD,
    GET_SPLUNK_DEFAULT_THRESHOLD_SUCCESS,
    GET_SPLUNK_DEFAULT_THRESHOLD_FAIL,
    GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    GET_SPLUNK_RESOURCE_BY_ID,
    GET_SPLUNK_RESOURCE_BY_ID_SUCCESS,
    GET_SPLUNK_RESOURCE_BY_ID_FAIL,
    GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID,
    GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
    GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID_FAIL,
    GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
    GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
    GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
    GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
    GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
    GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
    GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD,
    GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS,
    GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD_FAIL,
    GET_SPLUNK_RESOURCES,
    GET_SPLUNK_RESOURCES_SUCCESS,
    GET_SPLUNK_RESOURCES_FAIL,
    PUT_SPLUNK_THRESHOLD,
    PUT_SPLUNK_THRESHOLD_SUCCESS,
    PUT_SPLUNK_THRESHOLD_FAIL,
    POST_SPLUNK_DISABLE_THRESHOLD_ALERTS,
    POST_SPLUNK_DISABLE_THRESHOLD_ALERTS_SUCCESS,
    POST_SPLUNK_DISABLE_THRESHOLD_ALERTS_FAIL,
    POST_SPLUNK_ENABLE_THRESHOLD_ALERTS,
    POST_SPLUNK_ENABLE_THRESHOLD_ALERTS_SUCCESS,
    POST_SPLUNK_ENABLE_THRESHOLD_ALERTS_FAIL,
    POST_SPLUNK_DISABLE_ALERTS,
    POST_SPLUNK_DISABLE_ALERTS_SUCCESS,
    POST_SPLUNK_DISABLE_ALERTS_FAIL,
    POST_SPLUNK_ENABLE_ALERTS,
    POST_SPLUNK_ENABLE_ALERTS_SUCCESS,
    POST_SPLUNK_ENABLE_ALERTS_FAIL,
    POST_SPLUNK_CREATE_RESOURCE_ALERTS,
    POST_SPLUNK_CREATE_RESOURCE_ALERTS_SUCCESS,
    POST_SPLUNK_CREATE_RESOURCE_ALERTS_FAIL,
    PUT_SPLUNK_ALERTS,
    PUT_SPLUNK_ALERTS_SUCCESS,
    PUT_SPLUNK_ALERTS_FAIL,
} from "./actionTypes";

export const getSplunkRefresh = () => ({
    type: GET_SPLUNK_REFRESH
})

export const getSplunkRefreshSuccess = (data) => ({
    type: GET_SPLUNK_REFRESH_SUCCESS,
    payload: data
})

export const getSplunkRefreshFail = (error) => ({
    type: GET_SPLUNK_REFRESH_FAIL,
    payload: error
})

export const getSplunkAllResourceAlertsPage = (page_filters) => ({
    type: GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE,
    payload: { page_filters }
})

export const getSplunkAllResourceAlertsPageSuccess = (data) => ({
    type: GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    payload: data
})

export const getSplunkAllResourceAlertsPageFail = (error) => ({
    type: GET_SPLUNK_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    payload: error
})

export const getAllOrgSplunkResourceTypes = () => ({
    type: GET_ALL_ORG_SPLUNK_RESOURCE_TYPES
})

export const getAllOrgSplunkResourceTypesSuccess = (data) => ({
    type: GET_ALL_ORG_SPLUNK_RESOURCE_TYPES_SUCCESS,
    payload: data
})

export const getAllOrgSplunkResourceTypesFail = (error) => ({
    type: GET_ALL_ORG_SPLUNK_RESOURCE_TYPES_FAIL,
    payload: error
})

export const getSplunkAllResourceCount = (page_filters) => ({
    type: GET_SPLUNK_ALL_RESOURCE_COUNT,
    payload: { page_filters }
})

export const getSplunkAllResourceCountSuccess = (data) => ({
    type: GET_SPLUNK_ALL_RESOURCE_COUNT_SUCCESS,
    payload: data
})

export const getSplunkAllResourceCountFail = (error) => ({
    type: GET_SPLUNK_ALL_RESOURCE_COUNT_FAIL,
    payload: error
})

export const getSplunkRefreshScanStatus = () => ({
    type: GET_USER_RESCAN_STATUS_SPLUNK
})

export const getSplunkRefreshScanStatusSuccess = (data) => ({
    type: GET_USER_RESCAN_STATUS_SPLUNK_SUCCESS,
    payload: data
})

export const getSplunkRefreshScanStatusFail = (error) => ({
    type: GET_USER_RESCAN_STATUS_SPLUNK_FAIL,
    payload: error
})

export const postSplunkServiceMapping = (service_mapping) => ({
    type: POST_SPLUNK_SERVICE_MAPPING,
    payload: { service_mapping }
})

export const postSplunkServiceMappingSuccess = (data) => ({
    type: POST_SPLUNK_SERVICE_MAPPING_SUCCESS,
    payload: data
})

export const postSplunkServiceMappingFail = (error) => ({
    type: POST_SPLUNK_SERVICE_MAPPING_FAIL,
    payload: error
})

export const postSplunkResourceOpsgenieTeamMapping = (splunk_resource_team_mapping) => ({
    type: POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING,
    payload: { splunk_resource_team_mapping }
})

export const postSplunkResourceOpsgenieTeamMappingSuccess = (data) => ({
    type: POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    payload: data
})

export const postSplunkResourceOpsgenieTeamMappingFail = (error) => ({
    type: POST_SPLUNK_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    payload: error
})

export const postSplunkResourcePagerDutyServiceMapping = (splunk_resource_pagerduty_service_mapping) => ({
    type: POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING,
    payload: { splunk_resource_pagerduty_service_mapping }
})

export const postSplunkResourcePagerDutyServiceMappingSuccess = (data) => ({
    type: POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING_SUCCESS,
    payload: data
})

export const postSplunkResourcePagerDutyServiceMappingFail = (error) => ({
    type: POST_SPLUNK_RESOURCE_PAGERDUY_SERVICE_MAPPING_FAIL,
    payload: error
})

export const getSpunkAllServiceDependencyResourceAlertsPage = (page_filters) => ({
    type: GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE,
    payload: { page_filters }
})

export const getSpunkAllServiceDependencyResourceAlertsPageSuccess = (data) => ({
    type: GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_SUCCESS,
    payload: data
})

export const getSpunkAllServiceDependencyResourceAlertsPageFail = (error) => ({
    type: GET_SPUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_ALERTS_PAGE_FAIL,
    payload: error
})

export const getSplunkAllServiceDependencyResourceCount = (page_filters) => ({
    type: GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT,
    payload: { page_filters }
})

export const getSplunkAllServiceDependencyResourceCountSuccess = (data) => ({
    type: GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_SUCCESS,
    payload: data
})

export const getSplunkAllServiceDependencyResourceCountFail = (error) => ({
    type: GET_SPLUNK_ALL_SERVICE_DEPENDENCY_RESOURCE_COUNT_FAIL,
    payload: error
})

export const getSplunkAlerts = (data) => ({
    type: GET_SPLUNK_ALERTS,
    payload: data
})

export const getSplunkAlertsSuccess = (data) => ({
    type: GET_SPLUNK_ALERTS_SUCCESS,
    payload: data
})

export const getSplunkAlertsFail = (error) => ({
    type: GET_SPLUNK_ALERTS_FAIL,
    payload: error
})

export const getSplunkDefaultThreshold = (data) => ({
    type: GET_SPLUNK_DEFAULT_THRESHOLD,
    payload: data
})

export const getSplunkDefaultThresholdSuccess = (data) => ({
    type: GET_SPLUNK_DEFAULT_THRESHOLD_SUCCESS,
    payload: data
})

export const getSplunkDefaultThresholdFail = (error) => ({
    type: GET_SPLUNK_DEFAULT_THRESHOLD_FAIL,
    payload: error
})

export const getSplunkMissingAlertsByResourceId = (data) => ({
    type: GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID,
    payload: data
})

export const getSplunkMissingAlertsByResourceIdSuccess = (data) => ({
    type: GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    payload: data
})

export const getSplunkMissingAlertsByResourceIdFail = (error) => ({
    type: GET_SPLUNK_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    payload: error
})

export const getSplunkResourceById = (data) => ({
    type: GET_SPLUNK_RESOURCE_BY_ID,
    payload: data
})

export const getSplunkResourceByIdSuccess = (data) => ({
    type: GET_SPLUNK_RESOURCE_BY_ID_SUCCESS,
    payload: data
})

export const getSplunkResourceByIdFail = (error) => ({
    type: GET_SPLUNK_RESOURCE_BY_ID_FAIL,
    payload: error
})

export const getSplunkDefaultThresholdByResourceId = (data) => ({
    type: GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID,
    payload: data
})

export const getSplunkDefaultThresholdByResourceIdSuccess = (data) => ({
    type: GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
    payload: data
})

export const getSplunkDefaultThresholdByResourceIdFail = (error) => ({
    type: GET_SPLUNK_DEFAULT_THRESHOLD_BY_RESOURCE_ID_FAIL,
    payload: error
})

export const getSplunkDynamicAlertsDeployedByResourceId = (data) => ({
    type: GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
    payload: data
})

export const getSplunkDynamicAlertsDeployedByResourceIdSuccess = (data) => ({
    type: GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
    payload: data
})

export const getSplunkDynamicAlertsDeployedByResourceIdFail = (error) => ({
    type: GET_SPLUNK_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
    payload: error
})

export const getSplunkMissingDynamicAlertsByResourceId = (data) => ({
    type: GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
    payload: data
})

export const getSplunkMissingDynamicAlertsByResourceIdSuccess = (data) => ({
    type: GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
    payload: data
})

export const getSplunkMissingDynamicAlertsByResourceIdFail = (error) => ({
    type: GET_SPLUNK_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
    payload: error
})

export const getSplunkDynamicDefaultThreshold = (data) => ({
    type: GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD,
    payload: data
})

export const getSplunkDynamicDefaultThresholdSuccess = (data) => ({
    type: GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS,
    payload: data
})

export const getSplunkDynamicDefaultThresholdFail = (error) => ({
    type: GET_SPLUNK_DYNAMIC_DEFAULT_THRESHOLD_FAIL,
    payload: error
})

export const getSplunkResources = () => ({
    type: GET_SPLUNK_RESOURCES
})

export const getSplunkResourcesSuccess = (data) => ({
    type: GET_SPLUNK_RESOURCES_SUCCESS,
    payload: data
})

export const getSplunkResourcesFail = (error) => ({
    type: GET_SPLUNK_RESOURCES_FAIL,
    payload: error
})

export const putSplunkThreshold = (thresholds) => ({
    type: PUT_SPLUNK_THRESHOLD,
    payload: { thresholds }
})

export const putSplunkThresholdSuccess = (data) => ({
    type: PUT_SPLUNK_THRESHOLD_SUCCESS,
    payload: data
})

export const putSplunkThresholdFail = (error) => ({
    type: PUT_SPLUNK_THRESHOLD_FAIL,
    payload: error
})

export const postSplunkDisableThresholdAlerts = (alerts) => ({
    type: POST_SPLUNK_DISABLE_THRESHOLD_ALERTS,
    payload: { alerts }
})

export const postSplunkDisableThresholdAlertsSuccess = (data) => ({
    type: POST_SPLUNK_DISABLE_THRESHOLD_ALERTS_SUCCESS,
    payload: data
})

export const postSplunkDisableThresholdAlertsFail = (error) => ({
    type: POST_SPLUNK_DISABLE_THRESHOLD_ALERTS_FAIL,
    payload: error
})

export const postSplunkEnableThresholdAlerts = (alerts) => ({
    type: POST_SPLUNK_ENABLE_THRESHOLD_ALERTS,
    payload: { alerts }
})

export const postSplunkEnableThresholdAlertsSuccess = (data) => ({
    type: POST_SPLUNK_ENABLE_THRESHOLD_ALERTS_SUCCESS,
    payload: data
})

export const postSplunkEnableThresholdAlertsFail = (error) => ({
    type: POST_SPLUNK_ENABLE_THRESHOLD_ALERTS_FAIL,
    payload: error
})

export const postSplunkDisableAlerts = (alerts) => ({
    type: POST_SPLUNK_DISABLE_ALERTS,
    payload: { alerts }
})

export const postSplunkDisableAlertsSuccess = (data) => ({
    type: POST_SPLUNK_DISABLE_ALERTS_SUCCESS,
    payload: data
})

export const postSplunkDisableAlertsFail = (error) => ({
    type: POST_SPLUNK_DISABLE_ALERTS_FAIL,
    payload: error
})

export const postSplunkEnableAlerts = (alerts) => ({
    type: POST_SPLUNK_ENABLE_ALERTS,
    payload: { alerts }
})

export const postSplunkEnableAlertsSuccess = (data) => ({
    type: POST_SPLUNK_ENABLE_ALERTS_SUCCESS,
    payload: data
})

export const postSplunkEnableAlertsFail = (error) => ({
    type: POST_SPLUNK_ENABLE_ALERTS_FAIL,
    payload: error
})

export const postSplunkCreateResourceAlerts = (alerts) => ({
    type: POST_SPLUNK_CREATE_RESOURCE_ALERTS,
    payload: { alerts }
})

export const postSplunkCreateResourceAlertsSuccess = (data) => ({
    type: POST_SPLUNK_CREATE_RESOURCE_ALERTS_SUCCESS,
    payload: data
})

export const postSplunkCreateResourceAlertsFail = (error) => ({
    type: POST_SPLUNK_CREATE_RESOURCE_ALERTS_FAIL,
    payload: error
})

export const putSplunkAlerts = (alerts) => ({
    type: PUT_SPLUNK_ALERTS,
    payload: { alerts }
})

export const putSplunkAlertsSuccess = (data) => ({
    type: PUT_SPLUNK_ALERTS_SUCCESS,
    payload: data
})

export const putSplunkAlertsFail = (error) => ({
    type: PUT_SPLUNK_ALERTS_FAIL,
    payload: error
})